<template>
  <div>
    <JqxButton ref="confirmEDI" :theme="'material'" :width="120" :height="40" :textPosition="'center'" v-on:click="confirmEDIinAttesa()">
      Conferma EDI
    </JqxButton>
  </div>
</template>
<script>
    import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
    export default {
        name: "AttesaEdiDetails",
        components: {
            JqxButton,
        },
        data: function () {
            return {}
        },
        methods: {
          confirmEDIinAttesa() {
                this.$parent.confirmEDIinAttesa();
            }
        }
    }
</script>

<style scoped>

</style>
